import { ref, computed, Ref } from 'vue';

interface HeaderOffsetState {
  bannerHeight: Ref<number>;
  headerHeight: Ref<number>;
  totalOffset: Ref<number>;
  updateBannerHeight: (height: number) => void;
  updateHeaderHeight: (height: number) => void;
}

// Singleton state shared across all components
const bannerHeight = ref(0);
const headerHeight = ref(0);
const totalOffset = computed(() => {
  const total = bannerHeight.value + headerHeight.value;
  return total;
});

export const useHeaderOffset = (): HeaderOffsetState => {
  const updateBannerHeight = (height: number) => {
    bannerHeight.value = height;
  };

  const updateHeaderHeight = (height: number) => {
    headerHeight.value = height;
  };

  return {
    bannerHeight,
    headerHeight,
    totalOffset,
    updateBannerHeight,
    updateHeaderHeight,
  };
};
